import { Button } from 'components/atoms/Button'
import { ModalLink } from 'components/atoms/ModalLink'
import type { ActionProps } from './types'

export const Action = ({ action, className = '' }: ActionProps) => {
  if (!action) return null
  const { text, href, modal, variant, buttonVariant } = action

  if (!text || text.trim() === '') return null

  const buttonProps = {
    variant,
    buttonVariant,
    className,
  }

  if (modal) {
    return (
      <ModalLink modal={modal} {...buttonProps}>
        {text}
      </ModalLink>
    )
  }

  return (
    <Button href={href || '#'} {...buttonProps}>
      {text}
    </Button>
  )
}
